export default __webpack_public_path__ + "static/media/33t.5225bddd.jpg";